import { IncentiveOffersListContextType } from '../types/IncentiveOffersListContextType';

export const incentiveOffersListInitValue: IncentiveOffersListContextType = {
  data: {
    societyId: '',
    societyName: '',
    sellOffers: [],
    buyOffers: [],
    beneficiaryOperations: [],
    sellOffersSummary: {
      offersCount: 0,
      unitsCount: 0,
      totalAmount: 0,
    },
    buyOffersSummary: {
      offersCount: 0,
      unitsCount: 0,
      totalAmount: 0,
    },
    activeOperationsCount: 0,
    totalOperationsCount: 0,
    sellOffersSortBy: 'price',
    buyOffersSortBy: 'price',
    isAdmin: false,
    isReadOnly: false,
    isLoading: true,
  },
  actions: {
    handleCreateSellOffer: () => {},
    handleCreateBuyOffer: () => {},
    handleViewOfferDetail: () => {},
    handleSellOffersSortChange: () => {},
    handleBuyOffersSortChange: () => {},
  },
};
